'use client';

import Script from 'next/script';

interface StructuredDataProps {
  type?: 'website' | 'article' | 'product' | 'organization';
  data?: any;
}

export function StructuredData({ type = 'website', data }: StructuredDataProps) {
  const getStructuredData = () => {
    const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || 'https://paircar.com';
    
    switch (type) {
      case 'website':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'PairCar',
          description: '香港領先的二手車交易平台，提供智能搜索、AI預測車價、即時聊天等功能',
          url: baseUrl,
          sameAs: [
            'https://www.facebook.com/people/PairCarcom/61564051015790/',
            'https://www.instagram.com/paircar.official/',
          ],
          potentialAction: {
            '@type': 'SearchAction',
            target: `${baseUrl}/used-cars?search={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        };
      
      case 'organization':
        return {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'PairCar',
          description: '香港領先的二手車交易平台',
          url: baseUrl,
          logo: `${baseUrl}/logo.svg`,
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+852-XXXX-XXXX',
            contactType: 'customer service',
            areaServed: 'HK',
            availableLanguage: ['Chinese', 'English'],
          },
          sameAs: [
            'https://www.facebook.com/people/PairCarcom/61564051015790/',
            'https://www.instagram.com/paircar.official/',
          ],
          address: {
            '@type': 'PostalAddress',
            addressCountry: 'HK',
            addressRegion: 'Hong Kong',
          },
        };
      
      case 'article':
        return {
          '@context': 'https://schema.org',
          '@type': 'Article',
          ...data,
        };
      
      case 'product':
        return {
          '@context': 'https://schema.org',
          '@type': 'Product',
          ...data,
        };
      
      default:
        return null;
    }
  };

  const structuredData = getStructuredData();

  if (!structuredData) return null;

  return (
    <Script
      id={`structured-data-${type}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData),
      }}
    />
  );
}